import { observer } from 'mobx-react';
import { useEffect } from 'react';
import OrdersHistoryTable from './OrdersHistoryTable';
import { Icons } from 'src/assets/fonts/Icons/icons';
import { DEBOUNCE_TIME } from 'src/constants/main';
import { localeStore } from 'src/mobx/localesStore';
import { ordersHistoryStore } from 'src/mobx/ordersHistoryStore/ordersHistoryStore';
import { LoadingStatus } from 'src/types/main';
import { formatImagePath } from 'src/utils/formatter';
import AdvancedFilter from 'src/view/components/AdvancedFilter';
import Button from 'src/view/components/Controls/ButtonComponent/Button';
import SearchInput from 'src/view/components/Controls/SearchInput/SearchInput';
import HeaderTitle from 'src/view/containers/Headers/components/HeaderTitle/HeaderTitle';
import Headers from 'src/view/containers/Headers/Headers';
import './styles.scss';
import Preloader from '~/view/components/Controls/Preloader';

const OrdersHistory = () => {
  useEffect(() => {
    ordersHistoryStore.getOrders();
  }, []);

  return (
    <div className="d-flex flex-column flex-grow-1">
      <div className="d-flex flex-column full-width">
        <Headers>
          <div className="d-flex flex-row align-items-center justify-content-between">
            <HeaderTitle title="orders_history" />
          </div>
        </Headers>
        <div className="d-flex flex-row justify-content-between mt-6 pr-4" style={{ height: 46 }}>
          <SearchInput
            value={ordersHistoryStore.searchValue}
            onChangeText={ordersHistoryStore.changeSearch}
            withResetIcon
            placeholder="search_all_orders"
            debounceDelay={DEBOUNCE_TIME.MEDIUM}
            className="orders-history-header__search mr-2"
            customPlaceholder
            inputClassName="color-dark text-size-16 family-medium"
            customPlaceholderTextClassName="color-graysection"
          />
          <AdvancedFilter store={ordersHistoryStore.advancedFilter} />
          <div className="flex-1" />
          <div className="d-flex flex-row gap-10">
            {ordersHistoryStore.newOrdersCount > 0 ? (
              <Button
                title={localeStore.t('show_new_orders', { number_of_new_orders: ordersHistoryStore.newOrdersCount })}
                onClick={ordersHistoryStore.getNewOrders}
                appearance="tertiary"
              />
            ) : null}
            <Button
              title={localeStore.t('export_to_excel')}
              onClick={ordersHistoryStore.downloadExportedDocument}
              loading={ordersHistoryStore.exportLoadingStatus === LoadingStatus.Loading}
              appearance="secondary"
            />
          </div>
        </div>
      </div>

      <div className="d-flex flex-column flex-grow-1 pt-4">
        {ordersHistoryStore.isOrdersNotFound ? (
          <div className="d-flex flex-column justify-content-center align-items-center mt-6">
            <img src={formatImagePath(`${Icons.OrdersHistory}.svg`)} alt={localeStore.t('no_matching_order')} className="image__no-found mb-6" />,
            <p className="family-medium text-size-24 color-gray2">{localeStore.t('no_matching_order')}</p>
          </div>
        ) : (
          <OrdersHistoryTable />
        )}
      </div>
      <Preloader visible={ordersHistoryStore.ordersLoadingStatus === LoadingStatus.Loading} />
    </div>
  );
};

export default observer(OrdersHistory);
